import { findNearestExchangeRate } from './currency.js';

export function getGeneralLedgerData(context) {
    const {
        assets = [],
        cashaccounts = [],
        interaccounttransfers = [],
        transactions = [],
        journalentries = [],
        purchaseinvoices = [],
        salesinvoices = [],
        assetaccounts = [],
        liabilityaccounts = [],
        equityaccounts = [],
        expenseaccounts = [],
        clients,
        suppliers,
        staff,
        items,
        startdate,
    } = context;

    let resultsArray = [];

    assets.forEach(asset => {
        let openingbalance = parseFloat(asset.amount || 0);

        if (!openingbalance) return;

        let amount = Math.abs(openingbalance);

        if (openingbalance > 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening balance - ' + asset.name,
                accounttype: 'assetaccounts',
                accountid: asset.assetaccountid,
                debit: amount,
                credit: 0,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Assets',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: 0,
                credit: amount,
                currencyid: asset.currencyid,
                type: 'equityaccounts',
                id: 'opening_balance_equity',
            });
        }

        if (openingbalance < 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Assets',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: amount,
                credit: 0,
                currencyid: asset.currencyid,
                type: 'equityaccounts',
                id: 'opening_balance_equity',
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening balance - ' + asset.name,
                accounttype: 'assetaccounts',
                accountid: asset.assetaccountid,
                debit: 0,
                credit: amount,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });
        }
    });

    interaccounttransfers.forEach(transfer => {
        let cashaccount = cashaccounts.find(cashaccount => cashaccount.id == transfer.to)
        resultsArray.push({
            ts: transfer.ts,
            name: transfer.name,
            accounttype: 'cashaccounts',
            accountid: transfer.from,
            fromtype: 'cashaccounts',
            from: cashaccount?.name || '',
            activity: 'operating',
            debit: 0,
            credit: parseFloat(transfer.fromamount),
            currencyid: transfer.fromcurrencyid,
            type: 'interaccounttransfers',
            id: transfer.id,
        });
        cashaccount = cashaccounts.find(cashaccount => cashaccount.id == transfer.from)
        resultsArray.push({
            ts: transfer.ts,
            name: transfer.name,
            accounttype: 'cashaccounts',
            accountid: transfer.to,
            fromtype: 'cashaccounts',
            from: cashaccount?.name || '',
            activity: 'operating',
            debit: parseFloat(transfer.toamount),
            credit: 0,
            currencyid: transfer.tocurrencyid,
            type: 'interaccounttransfers',
            id: transfer.id,
        });
    });

    cashaccounts.forEach(account => {
        let openingbalance = parseFloat(account.openingbalance || 0);
        if (!openingbalance) return;
        let amount = Math.abs(openingbalance);

        if (openingbalance > 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'cashaccounts',
                accountid: account.id,
                debit: amount,
                credit: 0,
                currencyid: account.currencyid,
                type: 'cashaccounts',
                id: account.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance (asd)',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: 0,
                credit: amount,
                currencyid: account.currencyid,
                type: 'equityaccounts',
                id: '',
            });
        }

        if (openingbalance < 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance (asd)',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: amount,
                credit: 0,
                currencyid: account.currencyid,
                type: 'equityaccounts',
                id: '',
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'cashaccounts',
                accountid: account.id,
                debit: 0,
                credit: amount,
                currencyid: account.currencyid,
                type: 'cashaccounts',
                id: account.id,
            });
        }
    });

    transactions
        .forEach(transaction => {
            let amount = parseFloat(transaction.amount);

            if (transaction.type == 'receipt') {
                if (transaction.fromtype == 'clients') {
                    let client = clients.find(client => client.id == transaction.from);
                    let basis = client?.basis;
                    let assetaccountid = client?.assetaccountid
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'incomeaccounts',
                            accountid: 'default_income_account',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'clients',
                            from: client.name || '',
                            activity: 'operating',
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'assetaccounts',
                            accountid: assetaccountid,
                            from: client.name || '',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'clients',
                            from: client.name || '',
                            activity: 'operating',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'clients',
                        from: client.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == transaction.from);
                    let basis = supplier?.basis;
                    let liabilityaccountid = supplier?.liabilityaccountid
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'suppliers',
                            from: supplier.name || '',
                            activity: 'operating',
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'suppliers',
                            from: supplier.name || '',
                            activity: 'operating',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'suppliers',
                        from: supplier.name || '',
                        activity: 'operating',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'assetaccounts') {
                    let assetaccount = assetaccounts.find(assetaccount => assetaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'assetaccounts',
                        accountid: assetaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'assetaccounts',
                        from: assetaccount.name || '',
                        activity: 'investing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'liabilityaccounts') {
                    let liabilityaccount = liabilityaccounts.find(liabilityaccount => liabilityaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'liabilityaccounts',
                        from: liabilityaccount.name || '',
                        activity: 'financing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'equityaccounts') {
                    let equityaccount = equityaccounts.find(equityaccount => equityaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'equityaccounts',
                        accountid: equityaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'equityaccounts',
                        from: equityaccount.name || '',
                        activity: 'financing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
            }

            if (transaction.type == 'payment') {
                if (transaction.totype == 'expenseaccounts') {
                    let expenseaccount = expenseaccounts.find(expenseaccount => expenseaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'expenseaccounts',
                        from: expenseaccount?.name || '',
                        fromid: expenseaccount?.id || '',
                        activity: 'operating',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'liabilityaccounts') {
                    let liabilityaccount = liabilityaccounts.find(liabilityaccount => liabilityaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'liabilityaccounts',
                        from: liabilityaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'assetaccounts') {
                    let assetaccount = assetaccounts.find(assetaccount => assetaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'assetaccounts',
                        from: assetaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'equityaccounts') {
                    let equityaccount = equityaccounts.find(equityaccount => equityaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'equityaccounts',
                        from: equityaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.beneficiarytype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == transaction.beneficiaryid);
                    let basis = supplier?.basis;
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'suppliers',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'suppliers',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                }
                if (transaction.beneficiarytype == 'staff') {
                    let staffmember = staff.find(staffmember => staffmember.id == transaction.beneficiaryid);
                    let basis = staffmember?.basis;
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'staff',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'staff',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'liabilityaccounts',
                            accountid: staffmember?.liabilityaccountid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                }
            }
        });

    journalentries
        .forEach((entry) => {
            entry.rows.forEach((row) => {
                let debit = parseFloat(row.debit);
                let credit = parseFloat(row.credit);

                if (row.accounttype == 'cashaccounts') {
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        fromtype: 'mixed',
                        from: 'mixed',
                        activity: 'mixed',
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'clients') {
                    let client = clients.find(client => client.id == row.accountid);
                    let assetaccountid = clients.find(client => client.id == row.accountid)?.assetaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'assetaccounts',
                        accountid: assetaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == row.accountid);
                    let liabilityaccountid = suppliers.find(supplier => supplier.id == row.accountid)?.liabilityaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: supplier.id,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'staff') {
                    let staffmember = staff.find(staffmember => staffmember.id == row.accountid);
                    let liabilityaccountid = staff.find(staffmember => staffmember.id == row.accountid)?.liabilityaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: staffmember?.id,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else {
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
            });
        });

    purchaseinvoices
        .forEach(invoice => {
            let invoiceAmount = parseFloat(invoice.amount);
            let supplier = suppliers.find(supp => supp.id == invoice.supplierid);
            resultsArray.push({
                ts: invoice.ts,
                name: invoice.name,
                accounttype: 'liabilityaccounts',
                accountid: supplier?.liabilityaccountid,
                debit: 0,
                credit: invoiceAmount,
                currencyid: invoice.currencyid,
                subaccountid: invoice.subaccountid,
                type: 'purchaseinvoices',
                id: invoice.id,
            });

            resultsArray.push({
                ts: invoice.ts,
                name: invoice.name,
                accounttype: 'suppliers',
                accountid: invoice.supplierid,
                debit: 0,
                credit: invoiceAmount,
                currencyid: invoice.currencyid,
                subaccountid: invoice.subaccountid,
                type: 'purchaseinvoices',
                id: invoice.id,
            });

            invoice.items.forEach(item => {
                const qty = parseFloat(item.itemquantity);
                let itemCost = parseFloat(item.itemcost);
                const total = qty * itemCost;

                if (item.accounttype == 'items') {
                    let incomeaccount = items.find(it => it.id == item.accountid);
                    resultsArray.push({
                        ts: invoice.ts,
                        name: invoice.name,
                        accounttype: 'items',
                        accountid: item.accountid,
                        debit: total,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'purchaseinvoices',
                        id: invoice.id,
                    });
                }
                if (item.accounttype == 'liabilityaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: invoice.name,
                        accounttype: 'liabilityaccounts',
                        accountid: item.accountid,
                        debit: total,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'purchaseinvoices',
                        id: invoice.id,
                    });
                }
                if (item.accounttype == 'expenseaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: invoice.name,
                        accounttype: 'expenseaccounts',
                        accountid: item.accountid,
                        debit: total,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'purchaseinvoices',
                        id: invoice.id,
                    });
                }
            });
        });

    salesinvoices
        .forEach(invoice => {
            let client = clients.find(client => client.id == invoice.clientid);
            let assetaccountid = clients.find(client => client.id == invoice.clientid)?.assetaccountid;
            resultsArray.push({
                ts: invoice.ts,
                name: invoice.name,
                accounttype: 'assetaccounts',
                accountid: assetaccountid,
                from: client.name || '',
                debit: invoice.amount,
                credit: 0,
                currencyid: invoice.currencyid,
                subaccountid: invoice.subaccountid,
                type: 'salesinvoices',
                id: invoice.id,
            });

            resultsArray.push({
                ts: invoice.ts,
                name: invoice.name,
                accounttype: 'clients',
                accountid: invoice.clientid,
                debit: invoice.amount,
                credit: 0,
                currencyid: invoice.currencyid,
                subaccountid: invoice.subaccountid,
                type: 'salesinvoices',
                id: invoice.id,
            });

            invoice.items.forEach(item => {
                const qty = parseFloat(item.itemquantity);
                const unitcost = parseFloat(item.itemprice);
                const total = qty * unitcost;

                if (item.accounttype == 'items') {
                    let incomeaccount = items.find(it => it.id == item.accountid);

                    resultsArray.push({
                        ts: invoice.ts,
                        name: item.description || invoice.name,
                        accounttype: 'incomeaccounts',
                        accountid: incomeaccount?.incomeaccountid,
                        debit: 0,
                        credit: total,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'salesinvoices',
                        id: invoice.id,
                    });
                }
                if (item.accounttype == 'liabilityaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: item.description || invoice.name,
                        accounttype: 'liabilityaccounts',
                        accountid: item.accountid,
                        debit: 0,
                        credit: total,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'salesinvoices',
                        id: invoice.id,
                    });
                }
            });
        });

    resultsArray.sort((a, b) => a.ts - b.ts);

    return resultsArray;
}

export function getledgerbalance(accountledgers, exchangerates, selectedcurrency, type) {
    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = 0; i < accountledgers.length; i++) {
        const item = accountledgers[i];

        if (item.currencyid !== selectedcurrency) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrency).exchangerate;
            totalDebit += Number(item.debit) * rate || 0;
            totalCredit += Number(item.credit) * rate || 0;
        }
        else {
            totalDebit += Number(item.debit) || 0;
            totalCredit += Number(item.credit) || 0;
        }
    }
    switch (type) {
        case "clients":
        case "cashaccounts":
        case "assetaccounts":
        case "expenseaccounts":
            return totalDebit - totalCredit;

        case "suppliers":
        case "staff":
        case "liabilityaccounts":
        case "equityaccounts":
        case "incomeaccounts":
            return totalCredit - totalDebit;
    }
}